import common from './common.json';
import ho from './ho.json';
import leads from './leads.json';
import obx from './obx.json';
import sales from './sales.json';

const en = {
  ...common,
  obx,
  ho,
  sales,
  leads,
};

export default en;
